module.exports = __webpack_public_path__ + "img/ipadpro3_splash.be60da51.png";